"use client";
import { useEffect, useRef, useState } from "react";

const useElementResize = () => {
    const elementRef = useRef<HTMLDivElement | null>(null);
    const [dimensions, setDimentions] = useState({ width: 0, height: 0 });

    useEffect(() => {
        const element = elementRef?.current;
        if (!element) return;

        const observer = new ResizeObserver((entries) => {
            const { width, height } = entries[0].target.getBoundingClientRect();
            const newWidth = Math.round(width);
            const newHeight = Math.round(height);
            setDimentions((prev) => {
                if (prev.width === newWidth && prev.height === newHeight) return prev;
                return { width: newWidth, height: newHeight };
            });
        });

        observer.observe(element);
        return () => observer.disconnect();
    }, []);

    return {
        elementRef,
        width: dimensions.width,
        height: dimensions.height,
    };
};

export { useElementResize };
